{
  "agecCompliance": {
    "complete": "<strong1>{{percent}}%</strong1> Complétion",
    "compliant": "{{count}} produits conformes, cliquez <link1>ici</link1> pour les voir",
    "label": "Produits conformes / Non conformes",
    "nonCompliant": "{{count}} produits non conformes, cliquez <link1>ici</link1> pour les voir",
    "title": "Loi AGEC",
    "total": "<strong1>{{total}}</strong1> produits",
    "totalText": "Tous les produits importés"
  },
  "documents": {
    "certificateType": "Type",
    "complete": "<strong1>{{percent}}%</strong1> Complétion",
    "label": "Documents vérifiés / En attente",
    "noDocuments": {
      "message": "Veuillez lancer une campagne de certificats",
      "title": "Aucun document trouvé"
    },
    "pending": "A traiter",
    "title": "Certificats",
    "total": "<strong1>{{total}}</strong1> certificats",
    "totalText": "Vérifier les certificats en attente",
    "totalTextCompleted": "Félicitations ! Tous les certificats disponibles ont été validés",
    "verified": "Vérifiés"
  },
  "informationRequests": {
    "activityTier": "Rang",
    "average": "<strong1>{{days}} jours</strong1> Temps moyen de complétion",
    "closed": "Fermées",
    "collection": "Collection",
    "complete": "<strong1>{{percent}}%</strong1> Complétion",
    "ingestionDate": "Date d'ingestion",
    "ingestionDateFilter": {
      "moreThanSixMonths": "Plus de 6 mois",
      "oneMonth": "Moins d'1 mois",
      "oneToThreeMonths": "Entre 1 et 3 mois",
      "threeToSixMonths": "Entre 3 et 6 mois"
    },
    "label": "Requêtes ouvertes / Fermées",
    "noAverage": "Aucune réponse reçue",
    "noProducts": "Aucun produit",
    "noRequests": "Aucune requête",
    "open": "Ouvertes",
    "title": "Requêtes",
    "total": "<strong1>{{total}}</strong1> requêtes",
    "totalText": "Toutes les demandes d'informations envoyées à vos fournisseurs, y compris celles transférées et annulées",
    "type": "Catégorie"
  },
  "notifications": {
    "actions": {
      "copy": "Copier le message",
      "markAsDone": "Terminé"
    },
    "alerts": {
      "descriptions": {
        "expiredLaunchDate": "Produits commercialisés avec des données de traçabilité partielles",
        "incomingLaunchDate": "Requêtes incomplètes (échéance sous 3 semaines)"
      }
    },
    "archived": {
      "success": "Notification archivée avec succès"
    },
    "copy": {
      "messages": {
        "unanswered": "Pour rappel, nous avons besoin de votre aide pour faire progresser le processus de traçabilité entamé via la plateforme Trace For Good. Le manque d'informations de votre part bloque le processus, mais heureusement, nous n’avons besoin que de quelques minutes de votre temps !<eol/><eol/><bold>Si l'e-mail est dans votre boîte aux lettres</bold>, veuillez suivre les instructions.<eol/><eol/><bold>Si l'e-mail se trouve dans votre SPAM</bold>, veuillez le marquer comme \"non SPAM\" et suivre les instructions.<eol/><eol/><bold>Si l'e-mail n'est pas dans votre SPAM</bold>, veuillez suivre les instructions ci-dessous :<eol/>- Allez sur la page : https://app.traceforgood.com/login<eol/>- Cliquez sur \"Je suis un fournisseur\" et entrez votre adresse e-mail.<eol/>- Cliquez sur le lien reçu par e-mail pour accéder au questionnaire.<eol/><eol/>Pour toute question ou problème, veuillez contacter : support@traceforgood.com.<eol/>Merci d’avance pour votre aide.",
        "undelivery": "Il semblerait qu'un email envoyé par la plateforme Trace For Good, le logiciel de traçabilité que nous utilisons, n'ait pas pu vous être envoyé. Pour rappel, l'obtention de ces informations auprès de nos fournisseurs est obligatoire pour nous<eol/><eol/><bold>Si l'e-mail se trouve dans votre SPAM</bold>, veuillez le marquer comme \"non SPAM\" et suivre les instructions.<eol/><eol/><bold>Si l'e-mail n'est pas dans votre SPAM</bold>, veuillez suivre les instructions ci-dessous :<eol/><eol/>- Allez sur la page : https://app.traceforgood.com/login<eol/>- Cliquez sur \"Je suis un fournisseur\" et entrez votre adresse e-mail.<eol/>- Cliquez sur le lien reçu par e-mail pour accéder au questionnaire.<eol/><eol/>Pour toute question ou problème, veuillez contacter : [support@traceforgood.com](mailto:support@traceforgood.com).<eol/><eol/>Merci d’avance pour votre aide."
      },
      "success": "Message copié dans le presse-papier",
      "title": "Copiez le message dans le presse-papier"
    },
    "empty": {
      "alerts": "Aucune",
      "completed": "Aucune",
      "pending": "Aucune"
    },
    "language": {
      "english": "English",
      "french": "French"
    },
    "tab": {
      "alerts": "Spotlights (beta)",
      "completed": "Terminées",
      "pending": "À faire"
    },
    "title": "Notifications",
    "traceability": {
      "deliverability": {
        "action": "Envoyer un email manuellement",
        "cause": "L'email n'a pas pu être délivré"
      },
      "type": "Traçabilité",
      "unanswered": {
        "action": "Envoyer un rappel manuellement",
        "cause": "Le contact a des requêtes ouvertes"
      }
    }
  }
}
